import { render, staticRenderFns } from "./Gifting.vue?vue&type=template&id=70726896&scoped=true"
import script from "./Gifting.vue?vue&type=script&lang=js"
export * from "./Gifting.vue?vue&type=script&lang=js"
import style0 from "./Gifting.vue?vue&type=style&index=0&id=70726896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70726896",
  null
  
)

export default component.exports